import useImage, { DefaultLogoType } from "hooks/useImage";
import React, { FC } from "react";
import Icon from "./Icon";
import { DefaultLogoEnum } from "enums/enums";

type LogProps = React.ComponentProps<'img'> & {
    defaultLogo: DefaultLogoEnum
}
const Logo: FC<LogProps> = ({ defaultLogo, ...props }) => {
    const { logo } = useImage(props.src, defaultLogo)
    return (<Icon alt="logo" {...props} src={logo}  />);
}

export default Logo;